import React, { forwardRef } from 'react';

import { StyledDefaultGroupButton } from './styles';

interface DefaultGroupButtonProps {
    children: React.ReactNode;
    disabled?: boolean;
    onClick?: () => void;
}

// TODO: remove this component once variant has been added to Button component.
const DefaultGroupButton = forwardRef<HTMLButtonElement, DefaultGroupButtonProps>(
    ({ children, onClick, disabled = true, ...other }, ref) => {
        return (
            <StyledDefaultGroupButton ref={ref} disabled={disabled} onClick={onClick} {...other}>
                {children}
            </StyledDefaultGroupButton>
        );
    },
);

DefaultGroupButton.displayName = 'DefaultGroupButton';

export default DefaultGroupButton;
